import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntityDataService, NgrxDataModule } from 'ngrx-data';

import { LoginModule } from '../login/login.module';
import { entityConfig } from './entity-metadata';
import { I1FilenetServices } from './i1-filenet-services.service';
import { ObjectStoreDataService } from './object-store/object-store-data-service.service';
import { ObjectStoreService } from './object-store/object-store.service';
import { USER_DATA, userDataReducer } from './userData/user-data.reducer';
import { UserDataService } from './userData/user-data.service';
import { FolderDataService } from './folder/folder-data-service.service';
import { FolderService } from './folder/folder.service';
import { DocumentDataService } from './document/document-data-service.service';
import { DocumentService } from './document/document.service';
import { AspenDatePipe } from './pipes/aspen-dateformatter';
import { ChoiceListService } from './choice-list/choice-list.service';
import { ChoiceListDataService } from './choice-list/choice-list-data-service.service';
import { asyncChoiceListPipe } from './pipes/asyncChoiceList.pipe';
import { ACLServiceWeb } from './ACLServices-web.service';
import { BusinessOwnerDataService } from './business-owner/business-owner-data-service.service';
import { BusinessOwnerService } from './business-owner/business-owner.service';
import { AsyncBusinessOwnerEntityPipe } from './pipes/asyncBusinessOwnerEntity.pipe';
import { AsyncBusinessOwnerPipeAll } from './pipes/asyncBusinessOwnerAll.pipe';
import { asyncChoiceListChoicesPipe } from './pipes/asyncChoiceListChoices';
import { StringFilterByPipe } from './pipes/stringFilterBy.pipe';
import { FileUploadModule } from 'ng2-file-upload';
import { AsyncLegalCounselPipeAll } from './pipes/asyncLegalCounselAll.pipe';
import { LegalCounselService } from './legal-counsel/legal-counsel.service';
import { LegalCounselDataService } from './legal-counsel/legal-counsel-data.service';
import { AsyncLegalCounselEntityPipe } from './pipes/async-legal-counsel-entity.pipe';

@NgModule({
    declarations: [
        AspenDatePipe,
        asyncChoiceListPipe,
        AsyncBusinessOwnerEntityPipe,
        AsyncBusinessOwnerPipeAll,
        asyncChoiceListChoicesPipe,
        StringFilterByPipe,
        AsyncLegalCounselPipeAll,
        AsyncLegalCounselEntityPipe,
    ],
    imports: [
        CommonModule,
        StoreModule.forRoot([]),
        StoreModule.forFeature(USER_DATA, userDataReducer),
        EffectsModule.forRoot([]),
        NgrxDataModule.forRoot(entityConfig),
        LoginModule,
        FileUploadModule,
    ],
    exports: [
        AspenDatePipe,
        asyncChoiceListPipe,
        AsyncBusinessOwnerEntityPipe,
        AsyncBusinessOwnerPipeAll,
        asyncChoiceListChoicesPipe,
        StringFilterByPipe,
        AsyncLegalCounselPipeAll,
        AsyncLegalCounselEntityPipe,
    ],
    providers: [
        I1FilenetServices,
        ACLServiceWeb,
        ObjectStoreService,
        ObjectStoreDataService,
        FolderService,
        FolderDataService,
        DocumentService,
        DocumentDataService,
        ChoiceListService,
        ChoiceListDataService,
        BusinessOwnerDataService,
        BusinessOwnerService,
        UserDataService,
        LegalCounselService,
    ],
})
export class AclDataModule {
    constructor(
        entityDataService: EntityDataService,
        objectStoreDataService: ObjectStoreDataService,
        folderStoreDataService: FolderDataService,
        documentStoreDataService: DocumentDataService,
        choiceListDataService: ChoiceListDataService,
        businessOwnerDataServce: BusinessOwnerDataService,
        legalCounselDataService: LegalCounselDataService
    ) {
        entityDataService.registerService(
            'ObjectStore',
            objectStoreDataService
        );
        entityDataService.registerService('Folder', folderStoreDataService);
        entityDataService.registerService('Document', documentStoreDataService);
        entityDataService.registerService('ChoiceList', choiceListDataService);
        entityDataService.registerService(
            'BusinessOwner',
            businessOwnerDataServce
        );
        entityDataService.registerService(
            'LegalCounsel',
            legalCounselDataService
        );
    }
}
